module.exports = __webpack_public_path__ + "static/media/Kitchen.04784442.jpeg";